import type { Editor } from '@tiptap/core';

export type ParagraphConfidence = 'grounded' | 'weak' | 'ungrounded';

export interface ParagraphConfidenceInfo {
  position: number;
  confidence: ParagraphConfidence;
  citationCount: number;
}

export const computeParagraphConfidences = (editor: Editor): ParagraphConfidenceInfo[] => {
  const confidences: ParagraphConfidenceInfo[] = [];
  const { doc } = editor.state;

  doc.descendants((node, pos) => {
    if (node.type.name !== 'paragraph') {
      return;
    }

    const text = node.textContent.trim();
    if (!text || text.length < 40) {
      return;
    }

    let citationCount = 0;
    let hasGap = false;

    node.descendants((child) => {
      if (child.type.name === 'citation') {
        citationCount += 1;
      }
      if (child.type.name === 'gap') {
        hasGap = true;
      }
    });

    if (hasGap) {
      return;
    }

    const confidence: ParagraphConfidence =
      citationCount >= 2 ? 'grounded' : citationCount === 1 ? 'weak' : 'ungrounded';

    // Only decorate paragraphs that have at least one citation to avoid noisy styling.
    if (confidence === 'ungrounded') {
      return;
    }

    confidences.push({
      position: pos,
      confidence,
      citationCount,
    });
  });

  return confidences;
};
